export function modifyFieldsStructureInSurveyJson(surveyJson) {
    if (!surveyJson?.pages) return surveyJson;
    surveyJson.pages.forEach(page => {
        page.elements?.forEach(element => {

            // Sempre garante title preenchido
            if (!element.title || element.title.trim() === "") {
                element.title = element.name;
            }

            // Trata campos que possuem choices (dropdown, checkbox, radiogroup, ranking, etc)
            if (
                Array.isArray(element.choices) ||
                element.type === "ranking"
            ) {
                // Ranking pode não vir como choices, mas deve ser tratado igual
                element.choices = (element.choices || []).map(choice => {
                    if (typeof choice === "string") {
                        return { value: choice, text: choice };
                    }
                    if (typeof choice === "object" && choice !== null) {
                        return {
                            value: choice.value ?? choice.text,
                            text: choice.text ?? choice.value
                        };
                    }
                    return choice;
                });
            }

            // Avaliação (rating): trata rateValues
            if (element.type === "rating" && Array.isArray(element.rateValues)) {
                element.rateValues = element.rateValues.map(choice => {
                    if (typeof choice === "string") {
                        return { value: choice, text: choice };
                    }
                    if (typeof choice === "object" && choice !== null) {
                        return {
                            value: choice.value ?? choice.text,
                            text: choice.text ?? choice.value
                        };
                    }
                    return choice;
                });
            }

            // Booleano: garante labelTrue/labelFalse como string (pode customizar)
            if (element.type === "boolean") {
                if (!element.labelTrue) element.labelTrue = "Sim";
                if (!element.labelFalse) element.labelFalse = "Não";
            }

            // Datas: formata para padrão brasileiro
            if (element.type === "date") {
                // Garante formato brasileiro
                element.dateFormat = "dd/mm/yyyy";
                // Força o inputType (caso não esteja)
                if (!element.inputType || element.inputType !== "date") {
                    element.inputType = "date";
                }
            }

            // Data/hora: formata para padrão brasileiro
            if (element.type === "datetime") {
                element.dateFormat = "dd/mm/yyyy hh:MM";
                // Força o inputType (caso não esteja)
                if (!element.inputType || element.inputType !== "datetime-local") {
                    element.inputType = "datetime-local";
                }
            }
        });
    });
    return surveyJson;
}
